<template>
  <div id="app">
    <div v-if="hasParams">
      <router-view/>
    </div>
  </div>
</template>

<script>
import url from "./plugins/url";
import store from "@/store";

export default {
  name: "App",
  data() {
    return {
      hasParams: false,
      globalUserId:this.$store.state.userInfo.globalUserId,
      customFormId: url.GetQueryString('customFormId')
    }
  },
  created() {

    // console.log('globalUserId',this.globalUserId);
    this.init();
  },
  methods: {
    async init(){
      if (!this.$store.state.userInfo.globalUserId) {
        await  this.$store.dispatch("userInfo/init");
        this.getParamsJson();
      }else {
        this.getParamsJson();
      }
    },
    getParamsJson() {
      this.$api.getJsonParamsInfo({type: 'customForm', id: this.customFormId,globalUserId:this.$store.state.userInfo.globalUserId}).then((res)=>{
        this.$store.commit("userInfo/updateTenantId", res.content.tenantId);
        this.$store.commit("userInfo/updateInstanceId", res.content.instanceId);
        this.$store.commit("userInfo/updateModuleId", res.content.moduleId);
        this.hasParams=true;
      });
    }
  }
};
</script>
